
import React from 'react';
import { Language } from '../../types';

interface DocsSidebarProps {
  language: Language;
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  activeSection: string;
  setActiveSection: (id: string) => void;
  filteredDocs: any[];
}

const DocsSidebar: React.FC<DocsSidebarProps> = ({
  language,
  searchQuery,
  setSearchQuery,
  activeSection,
  setActiveSection,
  filteredDocs
}) => {
  const isRtl = language === 'ar';

  return (
    <aside className={`
       w-72 bg-white dark:bg-[#0a0a0c] border-${isRtl ? 'l' : 'r'} border-slate-200 dark:border-white/5 flex flex-col z-20 overflow-y-auto custom-scrollbar
    `}>
       <div className="p-6 border-b border-slate-100 dark:border-white/5 bg-slate-50/50 dark:bg-white/[0.01]">
          <h2 className="text-lg font-black text-slate-800 dark:text-white flex items-center gap-2">
             <i className="fas fa-book-open text-emerald-500"></i>
             {isRtl ? 'التوثيق والدليل' : 'Documentation'}
          </h2>
          <div className="mt-4 relative">
             <i className={`fas fa-search absolute ${isRtl ? 'right-3' : 'left-3'} top-1/2 -translate-y-1/2 text-slate-400 text-xs`}></i>
             <input 
                type="text" 
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder={isRtl ? "بحث في الوثائق..." : "Search docs..."}
                className={`w-full bg-white dark:bg-white/5 border border-slate-200 dark:border-white/10 rounded-xl py-2 ${isRtl ? 'pr-9 pl-3' : 'pl-9 pr-3'} text-xs font-bold dark:text-white outline-none focus:border-emerald-500 transition-all`}
             />
          </div>
       </div>
       <div className="p-3 space-y-1">
          {filteredDocs.map(doc => (
             <button
                key={doc.id}
                onClick={() => setActiveSection(doc.id)}
                className={`
                   w-full flex items-center gap-3 px-4 py-3 rounded-xl transition-all text-start
                   ${activeSection === doc.id 
                      ? 'bg-emerald-500 text-white shadow-lg shadow-emerald-500/20 font-black' 
                      : 'text-slate-500 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-white/5 font-bold'}
                `}
             >
                <i className={`fas ${doc.icon} w-5 text-center`}></i>
                <span className="text-xs">{isRtl ? doc.title.ar : doc.title.en}</span>
             </button>
          ))}
       </div>
       
       <div className="mt-auto p-4 border-t border-slate-100 dark:border-white/5">
          <div className="bg-slate-100 dark:bg-white/5 p-3 rounded-xl text-center">
             <p className="text-[10px] text-slate-500 dark:text-slate-400 font-bold mb-2">
                {isRtl ? 'تحتاج مساعدة إضافية؟' : 'Need more help?'}
             </p>
             <button className="text-emerald-500 text-xs font-black hover:underline">
                {isRtl ? 'تواصل مع الدعم' : 'Contact Support'}
             </button>
          </div>
       </div>
    </aside>
  );
};

export default DocsSidebar;
